import {type Component, type PublicProps} from "vue";

// see "vue-component-type-helpers" npm package
type ComponentProps<T> = T extends new (...args: any) => {
  $props: infer P;
} ? NonNullable<P> : T extends (props: infer P, ...args: any) => any ? P : {};

export type TabItem<T extends Component = Component> = {
  id: string;
  label?: string;
  component: T;
  props?: Omit<ComponentProps<T>, keyof PublicProps>;
}

export function defineTab<T extends Component>(tab: TabItem<T>, props?: Omit<ComponentProps<T>, keyof PublicProps>): TabItem<T> {
  return {...tab, props: (props ?? tab.props)};
}